// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"19":"chunk/not-found","695":"chunk/default-layout","971":"chunk/apply"}[chunkId] + "." + {"19":"65021f4f","695":"2783e2f7","971":"d650c7a3"}[chunkId] + ".css";
};